import React, { useState, useEffect } from "react";
import {
	KnowledgeBaseGrid,
	KnowledgeBaseModal,
} from "../components/KnowledgeBase";
import AvatarGallery from "../components/AvatarGallery";
import ChatInterface from "../components/ChatInterface";
import styles from "./InteractivePage.module.css";
import useKnowledgeBases from "../../shared/hooks/useKnowledgeBases.js";
import { useHttpClient } from "../../shared/hooks/http-hook";

const InteractivePage = () => {
	const {
		knowledgeBases,
		isLoading,
		error,
		createKnowledgeBase,
		updateKnowledgeBase,
		fetchUserOrganizations,
		showDropdown,
		userOrganizations,
		fetchKnowledgeBases,
	} = useKnowledgeBases();
	const { sendRequest } = useHttpClient();
	const [showChat, setShowChat] = useState(false);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [currentKnowledgeBase, setCurrentKnowledgeBase] = useState(null);
	const [avatars, setAvatars] = useState([]);
	const [isLoadingAvatars, setIsLoadingAvatars] = useState(false);
	const [avatarError, setAvatarError] = useState(null);
	const [selectedAvatar, setSelectedAvatar] = useState(null);
	// Get context values

	// Handler for opening the knowledge base modal
	const handleOpenModal = (knowledgeBase = null) => {
		setCurrentKnowledgeBase(knowledgeBase);
		setIsModalOpen(true);
	};

	// Handler for closing the knowledge base modal
	const handleCloseModal = () => {
		setIsModalOpen(false);
		setCurrentKnowledgeBase(null);
	};

	// Handler for saving a knowledge base (just close the modal, state is updated in context)
	const handleSaveKnowledgeBase = (knowledgeBase) => {
		fetchKnowledgeBases();
	};

	// Handler for selecting an avatar to chat with
	const handleSelectAvatar = (avatar) => {
		setSelectedAvatar(avatar);
		setShowChat(true);
	};

	// Handler for returning from chat to main view
	const handleBackToMain = () => {
		setShowChat(false);
	};

	useEffect(() => {
		const fetchAvatars = async () => {
			try {
				setIsLoadingAvatars(true);
				const response = await sendRequest(`/api/avatars-streaming`);
				if (response.data) {
					setAvatars(response.data);
				}
				setIsLoadingAvatars(false);
			} catch (err) {
				setIsLoadingAvatars(false);
				setAvatarError("Failed to load avatars.", err);
				console.error("Error fetching avatars:", err);
			}
		};
		fetchAvatars();
	}, [sendRequest]);

	return (
		<div className={styles.container}>
			{!showChat ? (
				// Main view with knowledge bases and avatars
				<>
					<div className={styles.header}>
						<h1 className={styles.title}>Knowledge Base</h1>
						<p className={styles.subtitle}>Create and manage knowledge base</p>
					</div>

					<section className={styles.section}>
						<KnowledgeBaseGrid
							onCreateNew={() => handleOpenModal()}
							onEdit={handleOpenModal}
							knowledgeBases={knowledgeBases}
							isLoading={isLoading}
							error={error}
						/>
					</section>

					<section className={styles.section}>
						<AvatarGallery
							onSelectAvatar={handleSelectAvatar}
							avatars={avatars}
							isLoadingAvatars={isLoadingAvatars}
							avatarError={avatarError}
						/>
					</section>

					<KnowledgeBaseModal
						isOpen={isModalOpen}
						knowledgeBase={currentKnowledgeBase}
						onClose={handleCloseModal}
						onSave={handleSaveKnowledgeBase}
						createKnowledgeBase={createKnowledgeBase}
						updateKnowledgeBase={updateKnowledgeBase}
						fetchUserOrganizations={fetchUserOrganizations}
						showDropdown={showDropdown}
						userOrganizations={userOrganizations}
					/>
				</>
			) : (
				// Chat view
				<ChatInterface
					selectedAvatar={selectedAvatar}
					knowledgeBases={knowledgeBases}
					onBack={handleBackToMain}
				/>
			)}
		</div>
	);
};

export default InteractivePage;
